import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#0043F7',
        secondary: '#70b4ff',
        error: '#B3261E',
        warning: '#A26C00'
      }
    }
  }
})
